import React from 'react'

const Product = () => {
  return (
    <div>Processing</div>
  )
}

export default Product